/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Admin_Traces_DescriptionInputs */

const es_walkthrough_admin_traces_description = /** @type {(inputs: Walkthrough_Admin_Traces_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitoreá la actividad del sistema: inicios de sesión, cambios de configuración, eliminaciones y más. Filtrá por tipo de evento, fecha o usuario.`)
};

const en_walkthrough_admin_traces_description = /** @type {(inputs: Walkthrough_Admin_Traces_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitor system activity: logins, configuration changes, deletions, and more. Filter by event type, date, or user.`)
};

/**
* | output |
* | --- |
* | "Monitor system activity: logins, configuration changes, deletions, and more. Filter by event type, date, or user." |
*
* @param {Walkthrough_Admin_Traces_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_admin_traces_description = /** @type {((inputs?: Walkthrough_Admin_Traces_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Admin_Traces_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_admin_traces_description(inputs)
	return en_walkthrough_admin_traces_description(inputs)
});
export { walkthrough_admin_traces_description as "walkthrough.admin_traces_description" }